import React, {Component} from 'react';
import {get} from '../../../api';
import {FormattedMessage} from 'react-intl';
import Label from "../../auth/components/Label";
import Dropdown from "../../cmp/Dropdown";
import CurrencyNumber from "../../cmp/CurrencyNumber";

class TopProductsAnalytics extends Component {

    state = {
        data: [],
        selectedRange: 'thismonth',
        limit: 5,
    }

    onSelectChange = (opt) => {
        this.setState({selectedRange: opt.value}, this.loadSelectedRange);
    };


    componentDidMount() {
        this.loadSelectedRange();
    }


    loadSelectedRange = () => {
        const val  = this.state.selectedRange
        switch (val) {
            case 'thismonth': {
                const now = new Date();
                const firstOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
                this.loadData(firstOfThisMonth, new Date().getTime());
            }
                break;
            case 'lastmonth': {
                const now = new Date();
                const start = new Date(now.getFullYear(), now.getMonth() - 2, 1);
                const end = new Date(start.getFullYear(), start.getMonth() + 1, 1).getTime() - 1;
                this.loadData(start.getTime(), end);
            }
                break;
            case 'last30days': {
                this.loadData(new Date().getTime() - 30 * 24 * 60 * 60 * 1000, new Date().getTime());
                break;
            }
            case 'alltime': {
                this.loadData(0, new Date().getTime());
                break;
            }


        }
    }
    loadData = (starttime, endtime) => {
        this.setState({loading: true});
        get(`/sales/products/${starttime}/${endtime}`)
            .then((data) => {
                this.setState({data, loading: false});
            }).catch(() => {
            this.setState({loading: false});
        });
    }
    showFullList = () => {
        this.setState({limit: this.state.data.length})
    }
    opts = [
        {
            label: <FormattedMessage id={"This month"}/>,
            value:'thismonth'
        },
        {
            label:  <FormattedMessage id={"Last month"}/>,
            value:'lastmonth'
        },
        {
            label: <FormattedMessage id={"Last 30 days"}/>,
            value:'last30days'
        },
        {
            label:   <FormattedMessage id={"All time"}/>,
            value:'alltime'
        },

    ]
    render() {

        if (this.state.data.length >= 0) {
            return (
                <div className={"card"}>
                    <div className="card-body">
                        <div className="d-flex justify-content-between">
                            <Label><FormattedMessage id={"Products Sold"}/></Label>
                            <Dropdown onSelected={this.onSelectChange}
                                      selected={this.opts.find((item)=>item.value === this.state.selectedRange)} opts={this.opts} />

                        </div>
                        <div className="display-4">
                            {
                                this.state.data.reduce((acc, cur) => acc + cur.quantity, 0)
                            }
                        </div>
                    </div>
                    <ul className={'list-group list-group-flush'}>
                        {
                            this.state.data.slice(0, this.state.limit).map(({title, commission, quantity}) => (
                                <li key={title}
                                    className={'list-group-item d-flex justify-content-between align-items-center'}>
                                    <span>{title}</span>
                                    <div className={"d-flex align-items-center"}>
                                    <small className={"text-success"}>{commission ? <CurrencyNumber value={commission} /> : null}</small>
                                    <span className={'ml-2 badge badge-info rounded-pill'}>{quantity}</span>
                                    </div>
                                </li>))
                        }
                    </ul>
                    {
                        this.state.data.length > this.state.limit && <div className="text-center">
                            <button className={"btn btn-link"} onClick={this.showFullList}>
                                <FormattedMessage id={"Show all"}/>
                            </button>
                        </div>
                    }
                </div>
            );
        } else {
            return null;
        }
    }
}


export default TopProductsAnalytics;
